import React from "react";
import { Link } from "react-router-dom";

import * as CHQ from "chq";

export const getStoryPath = (story: CHQ.Story) => {
  if (story?.question?.parentStoryQuestion) {
    return `/stories/trend/${story.question.parentStoryQuestion.id}/story/${story.id}`;
  }

  return `/stories/trend/${story.questionId || story.question?.id}/story/${story.id}`;
};

type StoryLinkProps = Omit<React.ComponentProps<typeof Link>, "to"> & {
  children: React.ReactNode;
  story: CHQ.Story;
  dismiss?: () => {};
};

const StoryLink: React.FC<StoryLinkProps> = ({ children, story, tabIndex, dismiss, ...props }) => (
  <Link
    {...props}
    onClick={() => {
      if (dismiss) {
        dismiss();
      }
    }}
    to={getStoryPath(story)}
    tabIndex={tabIndex || 0}
  >
    {children}
  </Link>
);

export default StoryLink;
